"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCircuitBreakerMaintenance = void 0;
const abstractMaintenanceItem_1 = require("./abstractMaintenanceItem");
const circuitBreakerState_1 = require("../resilience/circuitBreakerState");
/**
 * Maintenance for circuit breakers.
 */
class DefaultCircuitBreakerMaintenance extends abstractMaintenanceItem_1.AbstractMaintenanceItem {
    /**
     * Initializes a new instance of the @see CircuitBreakerMaintenance class.
     * @param proxies Proxies to use for maintenance.
     */
    constructor(proxies) {
        super(proxies);
    }
    /**
     * Sets a new state for all circuit breakers.
     * @param state New state for the circuit breakers.
     */
    setState(state) {
        for (const proxy of this.proxies) {
            const circuitBreaker = proxy;
            if (circuitBreaker &&
                typeof circuitBreaker.resetErrorCount === 'function') {
                circuitBreaker.setState(state);
            }
        }
    }
    /**
     * Sets the state to 'open' for all circuit breakers.
     */
    open() {
        this.setState(circuitBreakerState_1.CircuitBreakerState.Open);
    }
    /**
     * Sets the state to 'close' for all circuit breakers.
     */
    close() {
        this.setState(circuitBreakerState_1.CircuitBreakerState.Close);
    }
    /**
     * Reset error count to zero.
     */
    resetErrorCount() {
        for (const proxy of this.proxies) {
            const circuitBreaker = proxy;
            if (circuitBreaker &&
                typeof circuitBreaker.resetErrorCount === 'function') {
                circuitBreaker.resetErrorCount();
            }
        }
    }
}
exports.DefaultCircuitBreakerMaintenance = DefaultCircuitBreakerMaintenance;
//# sourceMappingURL=defaultCircuitBreakerMaintenance.js.map